<template>
  <div>
    <b-row>
      <b-col md="1">
      </b-col>
      <b-col md="10">
        <b-card>
          <b-card>
          <b-form-group
            label="Relevant:"
            label-cols-sm="4"
            label-align-sm="right"
            class="mb-0"
            v-slot="{ ariaDescribedby }"
          >
            <b-form-checkbox
              v-model="attr_copy['is-of-interest']"
              name="is-of-interest-check-button"
              switch
              :aria-describedby="ariaDescribedby"
            >
            </b-form-checkbox>
          </b-form-group>
          <b-form-group
            label="Reviewed:"
            label-cols-sm="4"
            label-align-sm="right"
            class="mb-0"
            v-slot="{ ariaDescribedby }"
          >
            <b-form-checkbox
              v-model="attr_copy['is-reviewed']"
              name="is-reviewed-check-button"
              switch
              :aria-describedby="ariaDescribedby"
            >
            </b-form-checkbox>
          </b-form-group>
          <hr/>
          {{description}}
          </b-card>
          <hr/>
          <b-form-file
            v-model="images"
            :state="Boolean(images)"
            placeholder="Choose an image or drop it here..."
            drop-placeholder="Drop image here..."
            multiple
          ></b-form-file>
          <div class="mt-3">Selected image: {{ images ? images.name : '' }}</div>
          <b-progress :value="in_progress" :max="max_progress" show-progress animated></b-progress>
          <b-button block variant="primary" @click="storeImages">Update Image</b-button>

          </b-card>
      </b-col>
      <b-col md="1">
        <data-operations
          :modified="modified"
          :can_update="canUpdate"
          :can_delete="canDelete"
          :can_help="canHelp"
          @update="doUpdate"
          @undo="doUndo"
          @delete="doDelete"
          @cancel="doCancel"
          @help="doHelp"
        ></data-operations>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {http_v1} from '@/axios'
import {belongsToDescription} from '@/utils'
import {deepEqual} from '@/utils'
import {amsMofifiedAttrs} from '@/utils'
import DataOperations from './DataOperations.vue'

export default {
  components: {
    DataOperations
  },
  props: {
    id: {
      Type: String
    },
    collection_id: {
      Type: String
    }
  },
  data () {
    return {
      ams_type: 'collection-images',
      ams_api_path: 'api/admin/v1/',
      modified: false,
      attr_copy: {},
      attr_orig: {},
      description: undefined,
      describe_belongs_to_parent: [
        {
          prepend: ' ',
          type: 'interests',
          description_attr: 'name',
          append: ' '
        }],
      describe_belongs_to: [
        {
          prepend: '',
          type: 'collections',
          description_attr: 'name',
          append: ' '
        }
      ],
      images: [],
      in_progress: 0,
      max_progress: 100,
      progressInfos: [],
      message: "",
      fileInfos: []
    }
  },
  computed: {
    canUpdate() {
      return (
        // this.attr_copy['is-reviewed']?.length > 0
        // && this.attr_copy['is-of-interest']?.length > 0
        true
      )
    },
    canDelete() {
      return true
    },
    canHelp() {
      return true
    }
  },
  methods: {
    uploadApi(file, onUploadProgress) {
      let formData = new FormData()
      formData.append("image", file)
      // formData.append("id", this.id)
      return http_v1.patch(this.apiResourcePath(), formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        },
        onUploadProgress
      })
    },
    uploadImage(idx, file) {
      this.progressInfos[idx] = { percentage: 0, fileName: file.name }
      this.uploadApi(file, (event) => {
        this.progressInfos[idx].percentage = Math.round(100 * event.loaded / event.total)
        this.in_progress = this.progressInfos[idx].percentage
      }).then((response) => {
        let prevMessage = this.message ? this.message + "\n" : ""
        this.message = prevMessage + response.data.message
      }).catch(() => {
        this.progressInfos[idx].percentage = 0
        this.message = "Could not upload the file:" + file.name
      })
    },
    storeImages () {
      this.message = ""
      for(let i = 0; i< this.images.length; i++ ) {
        this.uploadImage(i, this.images[i])
      }
      this.images = []
    },
    apiResourcePath() {
      return this.ams_api_path + this.ams_type.replace(/-/g, '_') + '/' + this.id
    },
    doUpdate() {
      this.callApi()
    },
    doUndo() {
        this.attr_copy = Object.assign( {}, this.attr_orig)
    },
    doCancel() {
      this.$router.go(-1)
    },
    doDelete() {
      http_v1.delete (
        this.apiResourcePath()
      ).then(response => {
        if( response.status == 204) {
          this.$router.go(-1)
        }
      }).catch(error => {
        if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
    },
    doHelp() {
      http_v1.get(this.ams_api_path + 'features', {
        params: {
          title: this.ams_type
        }
      }).then(response => {
        if( response.data) {
          let feature = response.data.data[0]
          this.$router.push( {path: '/features' + '/' + feature.id + '/show'} )
        }
      }).catch(error => {
        if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
    },
    callApi () {
      let attr_params = amsMofifiedAttrs(this.attr_copy, this.attr_orig)
      http_v1.patch (
         this.apiResourcePath(), {
          ...attr_params
        }
      ).then(() => {
        this.$router.go(-1)
      }).catch(error => {
        window.console.log(error)
        if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
    }
  },
  watch: {
    attr_copy : {
      handler() {
        if(deepEqual(this.attr_copy,this.attr_orig)) {
          this.modified = false
        }
        else {
          this.modified = true
        }
      },
      deep: true
    }
  },
  mounted () {
    http_v1.get(this.apiResourcePath(), {
    }).then(response => {
      if( response.data) {
        this.attr_copy = Object.assign( {}, response.data.data.attributes)
        this.attr_orig = Object.assign( {}, response.data.data.attributes)
        let item_description = belongsToDescription(
          response.data.data, response.data.included, this.describe_belongs_to
        )
        // Describe the Collection parent Object with relationships to included
        let parent_obj = response.data.included?.find( 
          el =>  
          el.type === "collections" && el.id === response.data.data.attributes['collection-id']
        )
        let parent_description = belongsToDescription(
          parent_obj, response.data.included, this.describe_belongs_to_parent
        )
        this.description = item_description + parent_description
        this.$emit('gotAttrs', this.attr_copy, this.description)
      }
    }).catch(error => {
      if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
  }
}
</script>